import { useEffect, useState } from "react";
import axios from "axios";
import { useSearchParams } from "react-router-dom";
import { useToast } from "./use-toast";
import { useContent } from "../contexts/ContentContext";
import { getConsultSource, clearConsultSource } from "../lib/consultSource";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const EMPTY_FORM = { name: "", email: "", phone: "", message: "", practice_area: "", referral_source: "", website: "" };

export function useContactForm() {
  const { toast } = useToast();
  const { practiceAreas, firm } = useContent();
  const [searchParams] = useSearchParams();
  const [form, setForm] = useState(EMPTY_FORM);
  const [submitting, setSubmitting] = useState(false);

  const areaParam = searchParams.get("area");
  useEffect(() => {
    const area = practiceAreas.find((p) => p.id === areaParam);
    if (area) setForm((prev) => ({ ...prev, practice_area: area.title }));
  }, [areaParam, practiceAreas]);

  const update = (key) => (e) => setForm((prev) => ({ ...prev, [key]: e.target.value }));
  const set = (key) => (v) => setForm((prev) => ({ ...prev, [key]: v }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      toast({ title: "Missing information", description: "Please fill in name, email, and a message." });
      return;
    }
    setSubmitting(true);
    try {
      await axios.post(`${API}/contact`, { ...form, consult_source: getConsultSource() });
      clearConsultSource();
      toast({ title: "Thank you", description: "We've received your inquiry and will respond shortly." });
      setForm(EMPTY_FORM);
    } catch (err) {
      const detail = err.response?.data?.detail;
      toast({
        title: "Something went wrong",
        description: typeof detail === "string" ? detail : `We couldn't send your message. Please try again or email us directly at ${firm?.email || "civillaw@hbhslaw.com"}.`,
      });
    } finally {
      setSubmitting(false);
    }
  };

  return { form, update, set, submit, submitting, practiceAreas };
}
